/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgAccordion = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M22 18v2H12v-2zM7.854 12.146l1.414 1.414-3.708 3.707-3.706-3.707 1.414-1.414 2.293 2.292zM22 14v2H12v-2zM4.414 2l3.707 3.707-3.707 3.707L3 8l2.292-2.293L3 3.414zM22 5v2H12V5z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgAccordion as Accordion };
